import axios from 'axios';
import { IBillingDetails } from '@/store/stores/settings-billing.store';
import { getCurrency } from '@/common/currency';
import { ICurrency } from '@/types/Currency';
import { getBooleanForBackend } from '@/common/helpers';
import { EnumPlans, EnumPaymentTypes } from '@/enums/Plans';

export const getBillingDetails = async (): Promise<IBillingDetails> => {
  const { data } = await axios.get('/get/settings/billing');
  const { subscription = {} } = data;
  return {
    activeUserCount: data.active_user_count,
    billingCurrency: getCurrency(data.billing_currency),
    contactCount: data.contact_count,
    documentCount: data.document_count,
    endDate: data.end_date,
    entityId: data.entity_id,
    paymentDate: data.payment_date,
    planCode: data.plan_code,
    planDescription: data.plan_description,
    planName: data.plan_name || '',
    planTitle: data.plan_title,
    signedCount: data.signed_count,
    smsCount: data.sms_count,
    smsIncluded: data.sms_included,
    startDate: data.start_date,
    subscription: {
      currentTermEnd: subscription.current_term_end,
      currentTermStart: subscription.current_term_start,
      dueInvoicesCount: subscription.due_invoices_count,
      dueSince: subscription.due_since,
      planQuantity: subscription.plan_quantity,
      status: subscription.status,
      totalDues: subscription.total_dues,
    },
    subscriptionId: data.subscription_id,
    upgradeable: data.upgradeable,
    userCount: subscription.plan_quantity || data.active_user_count,
  };
};

export const setBillingCurrency = async (
  entityId: string,
  currency: ICurrency
): Promise<number> => {
  const body = new FormData();
  body.append('action', 'entity');
  body.append('id', entityId);
  body.append('field', 'entity-billing_currency');
  body.append('value', currency.key);

  const {
    data: { status = 0 },
  } = await axios.post('/save/settings', body);
  return status;
};

export const upgrade = async ({
  currency,
  planType,
  activeUserCount,
  userCount,
  frequency,
  campaign = '',
  subscriptionId,
  confirmed,
  paymentType,
}) => {
  const type = paymentType === EnumPaymentTypes.invoice ? 'invoice-' : '';
  const billingFrequncy = `${type}${frequency}-${currency.key.toLowerCase()}`;
  const body = new FormData();
  body.append('entity-billing_currency', currency.key);
  body.append('entity-plan', planType);
  body.append('entity-plan-users', userCount);
  body.append('entity-billing_frequency', billingFrequncy);
  body.append('entity-plan-campaign', campaign);
  body.append('entity-plan-currency', currency.key);
  body.append('entity-subscription-id', subscriptionId || '');
  body.append('entity-plan-current-users', activeUserCount);
  body.append('update-confirmed', getBooleanForBackend(confirmed));

  const { data } = await axios.post('/get/settings/plan-submit', body);
  return data;
};

export const getUpgradeEstimate = async (
  planType: EnumPlans,
  userCount: number,
  billingCurrency: ICurrency,
  subscriptionId: string
) => {
  const body = new FormData();
  body.append('action', 'plan-estimate');
  body.append('entity-plan', `${planType}`);
  body.append('entity-plan-users', `${userCount}`);
  body.append('entity-plan-currency', billingCurrency.key);
  body.append('entity-subscription-id', subscriptionId);

  const { data } = await axios.post('/get/settings', body);
  return data;
};
